import { Button, useNotifications } from '@ph-react-ui/core';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useGetPaymentSchemeById } from '../../../hooks/payment-schemes/useGetSchemeById';
import { useUpdatePaymentSchemeStatus } from '../../../hooks/payment-schemes/useUpdateSchemeStatus';
import { useModal } from '../../../hooks/useModal';
import { UPDATE_SCHEME_STATUS } from '../../../utils/constants/payment-schemes/modals';
import { Dialog } from '../../shared/components/Dialog';

export const UpdateSchemeStatus = () => {
  const notification = useNotifications();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { close: closeModal } = useModal(UPDATE_SCHEME_STATUS);
  const updateSchemeStatus = useUpdatePaymentSchemeStatus();
  const id = searchParams.get('schemeId');

  const { data } = useGetPaymentSchemeById(id!);

  const statusActionTranslation = data?.status ? 'ACTIVE' : 'INACTIVE';

  const handleStatusChange = () => {
    const newStatus = data?.status ? 0 : 1;
    updateSchemeStatus
      .mutateAsync({ schemeId: id!, status: newStatus })
      .then(() => {
        const newStatusTranslation = newStatus ? 'INACTIVE' : 'ACTIVE';

        closeModal();
        notification.success(
          t(`PAYMENT_SCHEMES.MESSAGES.${newStatusTranslation}_SUCCESS`)
        );
        queryClient.invalidateQueries({ queryKey: ['payment-schemes', id] });
        queryClient.invalidateQueries({ queryKey: ['payment-schemes'] });
      })
      .catch((resError) => {
        notification.danger(t(`NETWORK_ERRORS.${resError.errors[0]}`));
      });
  };

  return (
    <Dialog
      onClose={() => closeModal()}
      dialogHeader={t(
        `PAYMENT_SCHEMES.ACTIONS.SET_${statusActionTranslation}_STATUS`
      )}
      actionButton={
        <Button onClick={handleStatusChange}>{t('ACTIONS.CONFIRM')}</Button>
      }
    >
      <>
        <h2>
          {t(
            `PAYMENT_SCHEMES.MESSAGES.ARE_YOU_SURE_${statusActionTranslation}`
          )}
        </h2>
      </>
    </Dialog>
  );
};
